/**
 * Haldiram wishlist — localStorage-backed, works without third-party app.
 */
(function () {
  const STORAGE_KEY = 'haldiram_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateHeaderCount(list.length);
  }

  function isInWishlist(productId) {
    return getWishlist().some((item) => String(item.productId) === String(productId));
  }

  function showToast(message) {
    let toast = document.querySelector('.wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'wishlist-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  function updateHeaderCount(count) {
    const icons = document.querySelectorAll('.h-wishlist-icon');
    icons.forEach((icon) => {
      let badge = icon.querySelector('.wishlist-header-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wishlist-header-count';
        icon.appendChild(badge);
      }
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
    const dashboardCount = document.querySelector('.wishlist-total-count');
    if (dashboardCount) {
      dashboardCount.textContent = count;
      dashboardCount.setAttribute('data-total', count);
    }
  }

  function ensureButtons() {
    document.querySelectorAll('.wishlist-engine').forEach((wrapper) => {
      if (wrapper.querySelector('.wishlist-engine-button')) return;

      const productId = wrapper.getAttribute('data-product_id');
      const productHandle = wrapper.getAttribute('data-product_handle');
      const variantId = wrapper.getAttribute('data-variant_id');
      const showLabel = wrapper.getAttribute('data-full_button') === 'true';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wishlist-engine-button';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.dataset.productId = productId;
      btn.dataset.productHandle = productHandle || '';
      btn.dataset.variantId = variantId;
      btn.innerHTML =
        '<span class="wishlist-icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="1.5" fill="none"/></svg></span>' +
        (showLabel ? '<span class="wishlist-label">Wishlist</span>' : '');

      wrapper.appendChild(btn);
    });
  }

  function syncButtonStates() {
    document.querySelectorAll('.wishlist-engine').forEach((wrapper) => {
      const productId = wrapper.getAttribute('data-product_id');
      const button = wrapper.querySelector('.wishlist-engine-button');
      if (!button) return;
      button.classList.toggle('wishlist-added', isInWishlist(productId));
    });
  }

  function toggleWishlist(productId, variantId, productHandle, button) {
    let list = getWishlist();

    if (isInWishlist(productId)) {
      list = list.filter((item) => String(item.productId) !== String(productId));
      saveWishlist(list);
      button.classList.remove('wishlist-added');
      showToast('Removed from wishlist');
    } else {
      list.push({
        productId: String(productId),
        variantId: String(variantId),
        handle: String(productHandle || ''),
      });
      saveWishlist(list);
      button.classList.add('wishlist-added');
      showToast('Added to wishlist');
    }
  }

  function init() {
    ensureButtons();
    syncButtonStates();
    updateHeaderCount(getWishlist().length);
  }

  document.addEventListener('click', (e) => {
    const button = e.target.closest('.wishlist-engine-button');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    const wrapper = button.closest('.wishlist-engine');
    const productId =
      wrapper?.getAttribute('data-product_id') || button.dataset.productId;
    const variantId =
      wrapper?.getAttribute('data-variant_id') || button.dataset.variantId;
    const productHandle =
      wrapper?.getAttribute('data-product_handle') || button.dataset.productHandle;

    if (!productId) return;
    toggleWishlist(productId, variantId, productHandle, button);
  });

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  /* Sync variant when product variant changes on PDP */
  document.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    if (!variant) return;
    document.querySelectorAll('.wishlist-engine[data-product_id]').forEach((wrapper) => {
      wrapper.setAttribute('data-variant_id', variant.id);
      const btn = wrapper.querySelector('.wishlist-engine-button');
      if (btn) btn.dataset.variantId = variant.id;
    });
  });
})();
